import React, { useEffect, useRef } from 'react';
import { ImageType } from '@types';
import useToggle from '@hooks/useToggle';
import Image from '@components/Image';
import ImgPlay from './img-play.png';
import ImgPause from './img-pause.png';

interface Props {
  src: string;
  thumb: string;
  className: string;
  onTimeChange: (val: number) => void;
}

function CoverVideo({ src, thumb, className, onTimeChange }: Props) {
  const videoRef = useRef<HTMLVideoElement>(null);
  const timerRef = useRef<number>();
  const playing = useToggle(false);
  const playMode = useToggle(false);

  useEffect(() => {
    return () => {
      stopTimer();
    };
  }, []);

  const stopTimer = () => {
    window.clearInterval(timerRef.current);
  };

  const handleVideoClick = () => {
    const video = videoRef.current;
    if (!video) return;
    if (video.paused) {
      video.play();
    } else {
      video.pause();
    }
  };

  const handlePlay = () => {
    const video = videoRef.current;
    if (!video) return;
    playing.on();
    timerRef.current = window.setInterval(() => {
      onTimeChange(video.duration - video.currentTime);
    }, 1000);
  };

  const handlePause = () => {
    stopTimer();
    playing.off();
  };

  const handleEnded = () => {
    stopTimer();
    if (videoRef.current) {
      onTimeChange(videoRef.current.duration);
    }
    playing.off();
    playMode.off();
  };

  const renderVideo = () => {
    if (playMode.isOn) {
      return (
        <video
          ref={videoRef}
          src={src}
          className={className}
          muted
          crossOrigin="anonymous"
          autoPlay
          onClick={handleVideoClick}
          onPlay={handlePlay}
          onPause={handlePause}
          onEnded={handleEnded}
        />
      );
    }
    return (
      <Image
        src={thumb}
        type={ImageType.media}
        className={className}
        onClick={() => playMode.on()}
      />
    );
  };

  return (
    <>
      {renderVideo()}
      <img
        draggable={false}
        className="pointer-events-none absolute h-40 w-40 cursor-pointer"
        alt=""
        src={playing.isOn ? ImgPause : ImgPlay}
      />
    </>
  );
}

export default CoverVideo;
